import React from 'react'


const Footer = () => {


    return (
        <div className="container-fluid footer-calc flex-calc">
            <p className="footer-text">&copy; 2022 Hashvich.am Բոլոր իրավունքները պաշտպանված են.</p>
        </div>
    )
}


export default React.memo(Footer)